import React, { Dispatch, memo, SetStateAction } from 'react'
import { ShipperRatesTableHeader } from 'apps/rms/components/ShipperRates/ShipperRatesTableHeader'
import { ShipperRatesTableRow } from 'apps/rms/components/ShipperRates/ShipperRatesTableRow'
import { IShipperRate, IShipperRatesParams, SORT_FIELD } from 'apps/rms/types/shipperRates'
import { Pagination, Table, TableBody } from 'transfix-ui'

interface IShipperRatesTableProps {
  shipperRates: IShipperRate[]
  totalCount: number
  params: IShipperRatesParams
  onPageChange: (page: number) => void
  onSortingChange: (sortField: SORT_FIELD) => void
  openAcceptanceCapModal: () => void
  setShipperRate: Dispatch<SetStateAction<IShipperRate | undefined>>
}

export const ShipperRatesTable = memo<IShipperRatesTableProps>(
  ({
    onPageChange,
    onSortingChange,
    openAcceptanceCapModal,
    params: { pageCount, perPage, sortField, sortOrder },
    setShipperRate,
    shipperRates,
    totalCount,
  }) => {
    const firstShipmentCount = pageCount * perPage

    if (shipperRates.length === 0) {
      return (
        <div className='tc mv2'>
          <h3>No rates found</h3>
          <p className='text-secondary'>Please try a new search.</p>
        </div>
      )
    }
    return (
      <>
        <p className='text-secondary'>
          <strong>
            {firstShipmentCount + 1}-{firstShipmentCount + shipperRates.length} of {totalCount}{' '}
            rates
          </strong>
        </p>
        <Table>
          <ShipperRatesTableHeader
            sortField={sortField}
            sortOrder={sortOrder}
            onSortingChange={onSortingChange}
          />
          <TableBody>
            {shipperRates.map(shipperRate => (
              <ShipperRatesTableRow
                key={shipperRate.id}
                shipperRate={shipperRate}
                openAcceptanceCapModal={openAcceptanceCapModal}
                setShipperRate={setShipperRate}
              />
            ))}
          </TableBody>
        </Table>
        <div className='tc'>
          <Pagination
            currentPage={pageCount + 1}
            numberOfPages={Math.ceil(totalCount / perPage)}
            onPageChange={onPageChange}
          />
        </div>
      </>
    )
  }
)
